import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api';
import {
  EmptyState,
  ErrorBox,
  Loader,
  PageHeader,
  StatusBadge,
  formatDateTime,
} from '../../components/Common';

export function MasterBookingsPage() {
  const [includeTerminal, setIncludeTerminal] = useState(false);
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['master-bookings', 'all', includeTerminal],
    queryFn: () => api.bookings.forMaster(includeTerminal),
  });

  return (
    <div>
      <PageHeader title="Записи" />
      <label className="mb-3 flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={includeTerminal}
          onChange={(e) => setIncludeTerminal(e.target.checked)}
        />
        Показывать историю
      </label>

      {isLoading && <Loader />}
      {error && <ErrorBox message={(error as Error).message} onRetry={() => void refetch()} />}
      {!isLoading && data && data.length === 0 && (
        <EmptyState icon="📋" title="Записей пока нет" />
      )}

      <ul className="space-y-2">
        {data?.map((b) => (
          <li key={b.id}>
            <Link to={`/bookings/${b.id}`} className="card flex items-center justify-between active:opacity-80">
              <div>
                <p className="font-semibold">{b.service?.name ?? 'Услуга'}</p>
                <p className="text-xs text-tg-hint">{formatDateTime(b.slot_start)}</p>
                <p className="text-xs text-tg-hint">Клиент: {b.client?.first_name ?? ''}</p>
              </div>
              <StatusBadge status={b.status} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
